import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ReconstructedInterventionService, RejectedField} from '../../stores/reconstructed-intervention.service';

interface FieldCorrection {
  enabled: boolean;
  field: string;
  fieldLabel: string;
  issue: string;
  correctValue: any;
}

@Component({
  selector: 'app-reject-dialog',
  templateUrl: './reject-dialog.component.html',
  styleUrls: ['./reject-dialog.component.scss']
})
export class RejectDialogComponent implements OnInit {
  @Output() onReject = new EventEmitter<void>();
  
  visible = false;
  interventionId: number;
  rejectionReason = '';
  
  fieldCorrections: FieldCorrection[] = [
    { enabled: false, field: 'working_area', fieldLabel: 'Superficie (ha)', issue: '', correctValue: null },
    { enabled: false, field: 'start_time', fieldLabel: 'Heure de Début', issue: '', correctValue: null },
    { enabled: false, field: 'stop_time', fieldLabel: 'Heure de Fin', issue: '', correctValue: null },
    { enabled: false, field: 'working_duration', fieldLabel: 'Durée de Travail', issue: '', correctValue: null },
    { enabled: false, field: 'fuel_consumption', fieldLabel: 'Consommation de Carburant', issue: '', correctValue: null },
    { enabled: false, field: 'intervention_type', fieldLabel: 'Type d\'Intervention', issue: '', correctValue: null },
    { enabled: false, field: 'field_id', fieldLabel: 'Parcelle', issue: '', correctValue: null },
    { enabled: false, field: 'other', fieldLabel: 'Autre', issue: '', correctValue: null }
  ];

  constructor(
    private reconstructedInterventionService: ReconstructedInterventionService
  ) {
  }

  ngOnInit(): void {
  }

  show(interventionId: number): void {
    this.interventionId = interventionId;
    this.rejectionReason = '';
    // Reset all field corrections
    this.fieldCorrections.forEach(fc => {
      fc.enabled = false;
      fc.issue = '';
      fc.correctValue = null;
    });
    this.visible = true;
  }

  close(): void {
    this.visible = false;
  }

  reject(): void {
    // Build rejected fields array from enabled corrections
    const rejectedFields: RejectedField[] = this.fieldCorrections
      .filter(fc => fc.enabled && fc.issue)
      .map(fc => ({
        field: fc.field,
        issue: fc.issue,
        correct_value: fc.correctValue
      }));

    // Rejection reason is now optional - use empty string if not provided
    const reason = this.rejectionReason?.trim() || '';

    this.reconstructedInterventionService.reject(
      this.interventionId, 
      reason,
      rejectedFields
    ).subscribe({
      next: () => {
        this.onReject.emit();
        this.close();
      },
      error: (err) => {
        console.error('Error rejecting intervention:', err);
        // Show error notification
      }
    });
  }
}

